import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import {
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Accordion as MuiAccordion,
  AccordionProps as MuiAccordionProps,
} from '@mui/material';
import clsx from 'clsx';
import { HTMLAttributes } from 'react';

type TableRowProps = MuiAccordionProps & {
  summary: string;
  children: React.ReactNode[];
};

const AccordionRow = ({
  summary,
  children,
  ...props
}: TableRowProps): JSX.Element => {
  return (
    <MuiAccordion disableGutters square elevation={0} {...props}>
      <MuiAccordionSummary expandIcon={<ArrowForwardIosSharpIcon />}>
        <span>{summary}</span>
      </MuiAccordionSummary>
      <MuiAccordionDetails>
        {children.map((child, i) => (
          <div key={i} className={clsx('px-4 py-1 odd:bg-gray-d3/50')}>
            {child}
          </div>
        ))}
      </MuiAccordionDetails>
    </MuiAccordion>
  );
};

type AccordionCellProps = {
  label?: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
};

const AccordionCell = ({
  label,
  children,
  onClick,
  className,
}: AccordionCellProps): JSX.Element => {
  return (
    <div
      onClick={() => onClick && onClick()}
      className={clsx('flex justify-between items-center', className)}
    >
      {label && <span className="font-bold">{label}</span>}
      <span className="text-right">{children}</span>
    </div>
  );
};

type Accordion_Props = HTMLAttributes<HTMLDivElement>;

function Accordion_(props: Accordion_Props) {
  return <div {...props} />;
}

export const Accordion = {
  Root: Accordion_,
  Row: AccordionRow,
  Cell: AccordionCell,
};
